import { Component, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NgClass } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-steper',
    templateUrl: './steper.component.html',
    styleUrls: ['./steper.component.scss'],
    imports: [
        TranslocoDirective,
        NgClass
    ]
})
export class SteperComponent {
  currentStep = 1;
  steps = [
    {
      path: 'customer',
      step: 1,
    },
    {
      path: 'establishment',
      step: 2,
    },
    {
      path: 'account',
      step: 3,
    },
    {
      path: 'payment',
      step: 4,
    },
    {
      path: 'success',
      step: 5,
    },
  ];

  private router = inject(Router);
  
  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        const routePath = event.url.split('/').pop();
        const existRouteStep = this.steps.find(step => step.path === routePath);
        this.currentStep = existRouteStep ? existRouteStep.step : 0;
      });
  }
}
